import { customDimensionToUserPropertyDictionary } from '../google-analytics/ga4Maps';
import type { CustomParamsUser } from '../google-analytics/ga4Types';

const isIOSInterface = () =>
  window.webkit &&
  window.webkit.messageHandlers &&
  window.webkit.messageHandlers.firebase;

const isAndroidInterface = () => window.AnalyticsWebInterface;

export interface FirebaseAdapter {
  trackEvent: (name: string, params: object) => void;
  setUserProperty: (name: string, value: unknown) => void;
}

const androidFirebaseClient: FirebaseAdapter = {
  trackEvent: (name, params) => {
    window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
  },
  setUserProperty: (name, value) => {
    window.AnalyticsWebInterface.setUserProperty(name, value);
  },
};

const iOSFirebaseClient: FirebaseAdapter = {
  trackEvent: (name, params) => {
    const message = {
      command: 'logEvent',
      name: name,
      parameters: params,
    };
    window.webkit.messageHandlers.firebase.postMessage(message);
  },
  setUserProperty: (name, value) => {
    const message = {
      command: 'setUserProperty',
      name,
      value,
    };
    window.webkit.messageHandlers.firebase.postMessage(message);
  },
};

const nullFirebaseClient: FirebaseAdapter = {
  trackEvent: () => {},
  setUserProperty: () => {},
};

const chooseFirebaseAdapter = (): FirebaseAdapter => {
  if (isAndroidInterface()) {
    return androidFirebaseClient;
  } else if (isIOSInterface()) {
    return iOSFirebaseClient;
  }
  return nullFirebaseClient;
};

export const createFirebaseAdapter = (): FirebaseAdapter => {
  return {
    trackEvent(name, params) {
      chooseFirebaseAdapter().trackEvent(name, params);
    },
    setUserProperty(name, params) {
      const firebaseName: keyof CustomParamsUser =
        customDimensionToUserPropertyDictionary[name] as keyof CustomParamsUser;
      if (!firebaseName) {
        return;
      }
      chooseFirebaseAdapter().setUserProperty(firebaseName, params);
    },
  };
};
